import React from "react";
import "leaflet/dist/leaflet.css";
import PiChart from "./PiChart";
import { Link } from "react-router-dom";

const ShareMarket = () => {
  const handleLogout = (event) => {
    event.preventDefault();
    sessionStorage.clear("token");
    window.location = "/login";
  };

  return (
    <div>
      <div className="navbar">
        <a href="/home">
          <img className="cpf-logo" src="/assets/cpf-logo.jpg" />
        </a>
        <button className="logout-btn" onClick={handleLogout}>
          Log out
        </button>
      </div>
      <div className="thailand-market-container">
        <div className="thailand-market-grid">
          <Link
            className="global-market-menuitem"
            to="/thailand-market/quantity-animal"
          >
            ปริมาณตัวสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/demand-animal"
          >
            ความต้องการอาหารสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/share-market"
          >
            ส่วนแบ่งการตลาดอาหารสัตว์
          </Link>
          <Link
            className="global-market-menuitem"
            to="/thailand-market/sale-animal"
          >
            ยอดขายอาหารสัตว์ CPF
          </Link>
        </div>
        <div className="geomap-powerbi">
          <iframe
            title="TH Market Share"
            width="1140"
            height="541.25"
            src="https://app.powerbi.com/reportEmbed?reportId=0107a744-d851-4b6b-b691-b63be454bdef&autoAuth=true&ctid=8c308e15-1480-4168-aed7-b0f7a1352095"
            frameborder="0"
            allowFullScreen="true"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default ShareMarket;
